import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Book from "./pages/Book";
import NotFound from "./pages/NotFound";
import Onboarding from "./pages/Onboarding";
import CaseStudies from "./pages/CaseStudies";
import Plans from "./pages/Plans";
import Reviews from "./pages/Reviews";
import Survey from "./pages/Survey";
import CounselorMarketingPlan from "./pages/CounselorMarketingPlan";

// Routed UI only. The Router (BrowserRouter on the client, StaticRouter on the
// server) and the shared providers (see AppProviders) are supplied by the entry
// points so the same tree can be hydrated on the client and prerendered on the server.
const App = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/book" element={<Book />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/case-studies" element={<CaseStudies />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/survey" element={<Survey />} />
      <Route path="/pricing" element={<Navigate to="/plans" replace />} />
      <Route path="/counselor-marketing-plan" element={<CounselorMarketingPlan />} />

      {/* Retired pages folded into the redesigned 6-page site — redirected to
          the closest new page/anchor to preserve SEO/backlink value. */}
      <Route path="/services" element={<Navigate to="/" replace />} />
      <Route path="/websites" element={<Navigate to="/plans#websites" replace />} />
      <Route path="/local-seo" element={<Navigate to="/case-studies#seo" replace />} />
      <Route path="/google-ads" element={<Navigate to="/case-studies#ads" replace />} />
      <Route path="/facebook-ads" element={<Navigate to="/plans" replace />} />
      <Route path="/fractional-cmo" element={<Navigate to="/plans" replace />} />
      <Route path="/team" element={<Navigate to="/about" replace />} />

      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </>
);

export default App;
